import BaseAPIService from '@/services/baseAPIService'

export default class TasksAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  // Resource Groups
  getResourceGroupList()                                { return this.httpClient.get(`/tasks/resourcegroups`) }
  getResourceGroup(id)                                  { return this.httpClient.get(`/tasks/resourcegroups/${id}`) }
  createResourceGroup(data)                             { return this.httpClient.post(`/tasks/resourcegroups`, data) }
  updateResourceGroup(id, data)                         { return this.httpClient.put(`/tasks/resourcegroups/${id}`, data) }
  updateResourceGroupBatch(listData)                    { return this.httpClient.put(`/tasks/resourcegroups`, listData) }
  archiveResourceGroup(id)                              { return this.httpClient.put(`/tasks/resourcegroups/${id}/archive`) }
  restoreResourceGroup(id)                              { return this.httpClient.put(`/tasks/resourcegroups/${id}/restore`) }

  // Resources
  getResourceList()                                     { return this.httpClient.get(`/tasks/resources`) }
  getResource(id)                                       { return this.httpClient.get(`/tasks/resources/${id}`) }
  createResource(data)                                  { return this.httpClient.post(`/tasks/resources`, data) }
  updateResource(id, data)                              { return this.httpClient.put(`/tasks/resources/${id}`, data) }
  archiveResource(id)                                   { return this.httpClient.put(`/tasks/resources/${id}/archive`) }
  restoreResource(id)                                   { return this.httpClient.put(`/tasks/resources/${id}/restore`) }

  // Tasks
  getTaskList(params = {}) {
    return this.cachedGet(`/tasks?${$.param(params)}`)
  }
  getTask(id)                                           { return this.httpClient.get(`/tasks/${id}`) }
  getTaskMapData(id)                                    { return this.httpClient.get(`/tasks/${id}/map`) }
  createTask(data)                                      { return this.httpClient.post(`/tasks`, data) }
  updateTask(id, data)                                  { return this.httpClient.put(`/tasks/${id}`, data) }
  cancelTask(id, data)                                  { return this.httpClient.post(`/tasks/${id}/cancel`, data) }
  closeTask(id)                                         { return this.httpClient.post(`/tasks/${id}/close`) }
  skipTaskPendingProduction(id)                         { return this.httpClient.post(`/tasks/${id}/skippendingproduction`) }
  getTaskPendingPanels(id)                              { return this.httpClient.get(`/tasks/${id}/pendingpanels`) }
  getTaskScannedItems(id)                               { return this.httpClient.get(`/tasks/${id}/scanneditems`) }

  approveTask(id, data)                                 { return this.httpClient.post(`/tasks/${id}/approve`, data) }
  denyTask(id, data)                                    { return this.httpClient.post(`/tasks/${id}/deny`, data) }
  recheckTaskApprovals(id)                              { return this.httpClient.post(`/tasks/${id}/recheckapprovals`) }

  // Task Items
  createTaskItem(id, data)                              { return this.httpClient.post(`/tasks/${id}/taskitems`, data) }
  cancelTaskItem(id, taskItemId, data)                  { return this.httpClient.post(`/tasks/${id}/taskitems/${taskItemId}/cancel`, data) }
  updateTaskItem(id, taskItemId, data)                  { return this.httpClient.put(`/tasks/${id}/taskitems/${taskItemId}`, data) }
  updateTaskItemBatch(id, data)                         { return this.httpClient.put(`/tasks/${id}/taskitems`, data) }
  completeTaskItem(id, taskItemId, data)                { return this.httpClient.post(`/tasks/${id}/taskitems/${taskItemId}/complete`, data) }

  // Task Items - Force Despatch List
  taskItemForceDespatchList(data)                       { return this.httpClient.post(`/tasks/taskitems/forcedespatchlist`, data) }

  // Tasks - Barcode Lookup
  runTaskBarcodeLookup(barcode)                         { return this.httpClient.get(`/tasks/barcode/lookup?barcode=${encodeURIComponent(barcode)}`) }

  // Manager Helper Functions
  calculateTaskRoute(data)                              { return this.httpClient.post(`/tasks/manager/calculateroute`, data) }
  calculateMappingData(params = {}) {
    return this.httpClient.get(`/tasks/manager/map?${$.param(params)}`)
  }
  getActiveTasksList(params = {}) {
    return this.httpClient.get(`/tasks/manager/activetasks?${$.param(params)}`)
  }

  // Order Despatch
  getTaskOrderList(orderIDList) {
    let params = { orders: orderIDList }
    return this.httpClient.get(`/tasks/orders?${$.param(params)}`)
  }

  // Purchase Order Pickup
  getTaskPurchaseOrderList(purchaseOrderIDList) {
    let params = { orders: purchaseOrderIDList }
    return this.httpClient.get(`/tasks/purchaseorders?${$.param(params)}`)    
  }

  // Tasks - Config Settings
  getConfigSettings()               { return this.httpClient.get(`/tasks/configuration/settings`) }
  updateConfigSettings(data)        { return this.httpClient.put(`/tasks/configuration/settings`, data) }

  // Tasks - Task Type Config
  getTaskType(id)                                     { return this.httpClient.get(`/tasks/tasktypes/${id}`) }
  getTaskTypeList(options = {}) {
    var params = {
      filter: options.filter || {}
    }
    
    var queryString = `/tasks/tasktypes?` + $.param(params)

    return this.httpClient.get(queryString)
  }
  createTaskType(data)                                { return this.httpClient.post(`/tasks/tasktypes`, data) }
  updateTaskType(id, data)                            { return this.httpClient.put(`/tasks/tasktypes/${id}`, data) }
}
